import { useAppStore } from "../stores/app";

const en = {
    required: "This field is required.",
    emailValidation: "Please enter a valid email address.",
    'First Name should be at least 2 characters long.': 'First Name should be at least 2 characters long.',
    "Error: First Name is required": 'Error: First Name is required',
    "Error: This field is required.": "Error: This field is required.",
    'Email is not in a valid format.': 'Email is not in a valid format.'
};

const ru = {
    'First Name should be at least 2 characters long.': 'Длина имени должна составлять не менее 2 символов.',
    'Error: First Name is required': 'Ошибка: Требуется указать имя',
    "Error: This field is required.": "Ошибка: Это поле является обязательным для заполнения.",
    'Email is not in a valid format.': 'Электронная почта имеет неправильный формат.'
}

export const getValidationMessage = (text) => {
    try {
        const appStore = useAppStore();
        const currentLang = appStore.getCurrentLang;
        const list = currentLang === 'ru' ? ru : en;

        return list[text] || text;

    } catch(err) {
        console.error(err);
    }
}